function initPlansGrid(block) {
    if (block.dataset.p7PlansInit) return;
    block.dataset.p7PlansInit = '1';

    const gridContainer = block.querySelector('.p7-series-plan-grid');
    const loadMoreBtn = block.querySelector('.p7-load-more');
    const loadingEl = block.querySelector('.p7-loading');
    const pagination = block.querySelector('.p7-series-plan-pagination');

    // Get attributes from the block itself
    const attributes = JSON.parse(block.dataset.attributes || '{}');
    const popupid = block.dataset.popupid;

    // Get ajaxurl and nonce from parent container since they're not on inner blocks
    const parentBlock = block.closest('.p7-series-plan-main-block');
    const ajaxurl = parentBlock ? parentBlock.dataset.ajaxurl : block.dataset.ajaxurl;
    // const nonce = parentBlock ? parentBlock.dataset.nonce : block.dataset.nonce;

    // if (!ajaxurl || !nonce) {
    //     console.error('Missing ajaxurl or nonce for plans grid');
    //     return;
    // }

    if (!ajaxurl) {
        console.error('Missing ajaxurl for plans grid');
        return;
    }

    let currentPage = 1;
    let maxPages = 1;
    let isLoading = false;

    function loadPlans(page = 1) {
        if (isLoading) return;
        isLoading = true;
        currentPage = page;

        // Show loading state
        if (page === 1 && !gridContainer.innerHTML.trim()) {
            loadingEl.style.display = "block";
        }
        gridContainer.style.display = "none";
        if (pagination) pagination.style.display = "none";

        if (page === 1) gridContainer.innerHTML = "";

        const body = new URLSearchParams({
            action: "p7_load_series_plan",
            page: page,
            popupid: popupid,
            attributes: JSON.stringify(attributes)
        });

        fetch(ajaxurl, {
            method: "POST",
            headers: { "Content-Type": "application/x-www-form-urlencoded" },
            body: body.toString()
        })
            .then(res => {
                if (!res.ok) {
                    throw new Error(`HTTP error! status: ${res.status}`);
                }
                return res.json();
            })
            .then(data => {
                if (!data.success) {
                    throw new Error(data.data?.message || 'Server returned error');
                }

                if (page === 1) {
                    gridContainer.innerHTML = data.data.html;
                } else {
                    gridContainer.insertAdjacentHTML("beforeend", data.data.html);
                }

                maxPages = data.data.max_pages;
                currentPage = data.data.current_page;

                if (loadMoreBtn) {
                    loadMoreBtn.style.display = currentPage < maxPages ? "flex" : "none";
                }

                // Re-initialize share buttons for newly loaded content
                initShareButtonsForBlock(block);
            })
            .catch(error => {
                console.error('Error loading plans:', error);
                gridContainer.innerHTML = `<p class="p7-error">Error loading plans. Please try again.</p>`;
            })
            .finally(() => {

                loadingEl.style.display = "none";
                gridContainer.style.display = "grid";
                if (pagination) pagination.style.display = "flex";

                if (typeof AOS !== "undefined") {
                    const aosElements = gridContainer.querySelectorAll('[data-aos]');
                    if (aosElements.length) {
                        requestAnimationFrame(() => AOS.refreshHard());
                    }
                }

                isLoading = false;

            });
    }

    if (loadMoreBtn) {
        loadMoreBtn.addEventListener('click', () => {
            const buttonPosition = loadMoreBtn.getBoundingClientRect().top + window.scrollY;

            loadPlans(currentPage + 1);

            const checkLoading = setInterval(() => {
                if (!isLoading) {
                    clearInterval(checkLoading);

                    window.scrollTo({
                        top: buttonPosition - 150,
                        behavior: "smooth"
                    });
                }
            }, 100);
        });
    }

    // Initialize share buttons for initial content
    initShareButtonsForBlock(block);

    // Load initial plans
    loadPlans();
}

function initShareButtonsForBlock(block) {
    // Find all share buttons within this specific block
    const shareButtons = block.querySelectorAll('.plan-series-share');

    shareButtons.forEach(btn => {
        // Remove existing listeners to prevent duplicates
        btn.removeEventListener('click', handleShareClick);
        btn.addEventListener('click', handleShareClick);
    });
}

function handleShareClick(e) {

    const btn = e.currentTarget;

    const popupId = btn.dataset.src;
    const title = encodeURIComponent(btn.dataset.title || "");
    const url = btn.dataset.url || "";
    const encodedUrl = encodeURIComponent(url);

    if (!popupId) {
        console.error('Share button missing data-src');
        return;
    }

    const popup = document.querySelector(popupId);

    if (!popup) {
        console.error('Popup not found:', popupId);
        return;
    }

    // Email
    const emailLink = popup.querySelector(".share-email");
    if (emailLink) {
        emailLink.href = `mailto:?subject=${title}&body=${encodedUrl}`;
    }

    // Facebook
    const fbLink = popup.querySelector(".share-facebook");
    if (fbLink) {
        fbLink.href =
            `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`;
    }

    // Copy link
    const copyBtn = popup.querySelector(".copy-link-btn");

    if (copyBtn && !copyBtn.dataset.bound) {
        copyBtn.dataset.bound = "true";
        // ensure SVG stays
        if (!copyBtn.querySelector(".copy-text")) {
            const textNode = document.createElement("span");
            textNode.className = "copy-text";
            textNode.textContent = "Copy Link";
            const svg = copyBtn.querySelector("svg");
            copyBtn.innerHTML = "";
            if (svg) copyBtn.appendChild(svg);
            copyBtn.appendChild(textNode);
        }

        const textEl = copyBtn.querySelector(".copy-text");
        copyBtn.addEventListener("click", async () => {
            try {
                await navigator.clipboard.writeText(url);
                const original = textEl.textContent;
                textEl.textContent = "Copied!";

                setTimeout(() => {
                    textEl.textContent = original;
                }, 2000);

            } catch (err) {
                console.log("Copy failed", err);
            }
        });
    }
}

function initializeAllBlocks() {
    document.querySelectorAll(".p7-series-plan-grid-block").forEach(initPlansGrid);
}

// Initialize when DOM is loaded
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeAllBlocks);
} else {
    initializeAllBlocks();
}

if (typeof jQuery !== 'undefined') {
    jQuery(document).on('ajaxComplete', function () {
        setTimeout(initializeAllBlocks, 100);
    });
}

/* TOUR POPUP HANDLER (global listener) */
document.addEventListener('click', function (e) {

    const btn = e.target.closest('.tour-series-plan.btn-scendery');
    if (!btn) return;

    const href = btn.getAttribute('href');

    if (!href || !href.startsWith('#')) return;

    e.preventDefault();

    const anchor = href.replace('#', '');

    const popupWrapper = document.querySelector(
        `.guten-popup-builder[data-anchor="${anchor}"]`
    );

    const popup = popupWrapper?.querySelector('.guten-popup');

    if (popup) {
        popup.classList.add('show');
    }

    // populate Gravity Forms fields
    setTimeout(() => {

        const plan = btn.dataset.plan || '';
        const community = btn.dataset.community || '';

        const communityField = popupWrapper?.querySelector('#input_9_6');
        const planField = popupWrapper?.querySelector('#input_9_7');

        if (communityField) communityField.value = community;
        if (planField) planField.value = plan;

    }, 300);

});